import { render, staticRenderFns } from "./FlowChildren.vue?vue&type=template&id=33c8b7b9&scoped=true&"
import script from "./FlowChildren.vue?vue&type=script&lang=js&"
export * from "./FlowChildren.vue?vue&type=script&lang=js&"
import style0 from "./FlowChildren.vue?vue&type=style&index=0&id=33c8b7b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c8b7b9",
  null
  
)

export default component.exports